import httpClient from '@/http-client'
import { baseMutations, baseState } from '@/store/mixins'

const BASE_URL = '/api/v2/payment/pre-invoices'

export default {
  namespaced: true,
  state: {
    ...baseState
  },
  mutations: {
    ...baseMutations
  },
  actions: {
    async fetch(context, attrubutes = {}) {
      let params = Object.assign(
        {
          page: context.state.pagination.currentPage,
          perPage: context.state.pagination.perPage,
          search: context.state.search
        },
        attrubutes
      )
      let response = await httpClient.get(BASE_URL, {
        params
      })
      context.commit('RECEIVE_RESOURCES', response.data)
      return response
    },
    getBranches() {
      return httpClient.get(`${BASE_URL}/options/branches`)
    },
    getDetail(context, id) {
      return httpClient.get(`${BASE_URL}/${id}`)
    },
    previewPdf(context, id) {
      return httpClient.get(`${BASE_URL}/preview-pdf/${id}`)
    },
    previewInvoicePdf(context, id) {
      return httpClient.get(`/api/invoices/generate-pdf/${id}`)
    },
    onDelete(context, data) {
      return httpClient.delete(`${BASE_URL}/${data.id}`, { data })
    },
    searchEnrollments(context, params = {}) {
      return httpClient.get(`${BASE_URL}/options/enrollments`, { params })
    },
    getMainPrograms() {
      return httpClient.get(`${BASE_URL}/options/main-programs`)
    },
    getSubPrograms(context, params = {}) {
      return httpClient.get(`${BASE_URL}/options/sub-programs`, { params })
    },
    getAcademicYears() {
      return httpClient.get(`${BASE_URL}/options/academic-years`)
    },
    getAcademicTerms(context, params = {}) {
      return httpClient.get(`${BASE_URL}/options/academic-terms`, { params })
    },
    getGrades(context, params = {}) {
      return httpClient.get(`${BASE_URL}/options/grades`, { params })
    },
    getStudyTimes() {
      return httpClient.get(`${BASE_URL}/options/study-times`)
    },
    getAcademicTarget(context, params = {}) {
      return httpClient.get(`${BASE_URL}/options/academic-target`, { params })
    },
    getFeeTypes(context, params = {}) {
      return httpClient.get(`${BASE_URL}/options/fee-types`, { params })
    },
    getFeeItems(context, params = {}) {
      return httpClient.get(`${BASE_URL}/options/fee-items`, { params })
    },
    getFeeDateRange(context, params = {}) {
      return httpClient.get(`${BASE_URL}/options/fee-date-range`, { params })
    },
    getFeeDiscount(context, params = {}) {
      return httpClient.get(`${BASE_URL}/options/fee-discount`, { params })
    },
    getExchangeRate(context, params = {}) {
      return httpClient.get(`${BASE_URL}/options/exchange-rate`, { params })
    },
    getKhqrBankAccounts(context, params = {}) {
      return httpClient.get(`${BASE_URL}/options/khqr-bank-accounts`, { params })
    },
    initKhqrPayment(context, data) {
      return httpClient.post('/api/payment/khqr/init', data)
    },
    getKhqrPaymentStatus(context, id) {
      return httpClient.get(`/api/payment/khqr/${id}/status`)
    },
    onSave(context, data) {
      return httpClient.post(BASE_URL, data)
    },
    onUpdate(context, data) {
      return httpClient.put(`${BASE_URL}/${data.id}`, data)
    }
  }
}
